import clsx from 'clsx';
import React, {FC, ReactNode} from 'react';

interface SectionProps {
  /** 区块底色：white（默认）或 muted（slate-50，用于与白底区块交替） */
  bg?: 'muted' | 'white';
  className?: string;
  /** 紧凑垂直节奏（py-10 lg:py-14），供文档页 hero 之后的正文区使用 */
  compact?: boolean;
  description?: ReactNode;
  id?: string;
  /** 传入则渲染标准区块标题块（居中，样式与首页 Stats/Trust 一致） */
  title?: ReactNode;
}

/**
 * v3 区块容器：统一 1440 容器（max-w-[90rem]）与垂直节奏（py-16 lg:py-24，compact 为 py-10 lg:py-14）。
 * 底色只用 white / muted 两档交替——首页家族没有深色内容带，深色仅出现在页脚。
 * 传 title/description 时渲染居中标题块；不传则完全自定义内容。
 */
const Section: FC<SectionProps> = ({bg = 'white', children, className, compact, description, id, title}) => (
  <section
    className={clsx(
      'relative',
      compact ? 'py-10 lg:py-14' : 'py-16 lg:py-24',
      bg === 'muted' ? 'bg-slate-50' : 'bg-white',
      className,
    )}
    id={id}
  >
    <div className="max-w-[90rem] mx-auto px-6 lg:px-8">
      {title && (
        <div className="max-w-2xl mx-auto text-center mb-12 lg:mb-16">
          <h2 className="font-display font-bold text-3xl lg:text-4xl text-slate-900 tracking-tight mb-4">{title}</h2>
          {description && <p className="text-slate-500 lg:text-lg leading-relaxed">{description}</p>}
        </div>
      )}
      {children}
    </div>
  </section>
);

export default Section;
